import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppThunk } from '../../../configureStore';
import FetchStatus from '../../../common/types/FetchStatus';

export type Todo = {
  id: number;
  owner: string;
  text: string;
};

type TodoState = {
  entities: Todo[];
  meta: {
    fetchStatus: FetchStatus;
  };
};

export const initialState: TodoState = {
  entities: [],
  meta: {
    fetchStatus: FetchStatus.none,
  },
};

const todoSlice = createSlice({
  name: 'todo',
  initialState,
  // These are your functions used to update the state.
  // The value returned from each function will be the new state of this slice
  reducers: {
    addTodo(state, action: PayloadAction<{ todo: Todo }>) {
      state.entities = [...state.entities, action.payload.todo];
      return state;
    },
  },
});

// Example of a thunk that adds a bunch of todo items to the state
export function seedTodosIfNecessary(): AppThunk<Promise<boolean | string>> {
  return function (dispatch) {
    // Make todo items
    const todos: Todo[] = [];
    for (let i = 0; i < 5; i++) {
      todos.push({
        id: i,
        owner: `owner-${i}`,
        text: `todo item ${i}`,
      });
    }

    // Add all items to the todo slice
    todos.forEach((todo) => {
      dispatch(todoSlice.actions.addTodo({ todo }));
    });

    return Promise.resolve(true);
  };
}

export const { addTodo } = todoSlice.actions;
export default todoSlice.reducer;
